<template>
  <div
      :aria-label="`${sanitizedTitle}`"
      class="tag-text"
      :class="{
      'tag-text--no-inverted': !inverted,
      'tag-text--inverted': inverted,
      'tag-text--background': !noBackground
    }"
  >
    {{ sanitizedTitle }}
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {sanitizeMarkedHeading} from "~/utils/data-transformers";

const props = defineProps({
  title: String,
  inverted: Boolean,
  noBackground: Boolean
})

const sanitizedTitle = computed(() => {
  return sanitizeMarkedHeading(props.title)
})

</script>

<style scoped lang="postcss">
.tag-text {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  border-radius: 55px;
  border-width: 1px;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 7px;
  padding-bottom: 7px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;

  &--no-inverted {
    border-color: var(--color-blue-aqua);
    color: #fff;
  }

  &--inverted {
    border-color: var(--color-blue-prussian);
    color: var(--color-blue-prussian);
  }

  &--background {
    background-color: rgb(2 0 66 / 0.2);
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
  }
}
</style>
